import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import { Typography } from '_atoms/Typography';
import { SelectInner } from './SelectInner';
import type { SelectProps } from './types';
import './select.scss';

export const Select: React.FC<SelectProps> = ({
  className,
  popupClassName,
  onChange,
  label,
  description,
  empty = null,
  inPopup,
  options,
  loading,
  itemProps,
  required,
  optional,
  mode,
  labelInValue,
  bulkActions,
  fetchAllOptions,
  ...props
}) => (
  <div className={cn('select-default', className)}>
    {label && (
      <Typography.Label>
        {label}
        {!!required && <span className="required"> *</span>}
        {optional && <span className="optional"> (optional)</span>}
      </Typography.Label>
    )}
    {description && <Typography.Caption>{description}</Typography.Caption>}
    <Form.Item {...itemProps}>
      <SelectInner
        onChange={(_: unknown, v: unknown) => onChange?.(v)}
        popupClassName={popupClassName}
        empty={empty}
        inPopup={inPopup}
        options={options}
        loading={loading}
        mode={mode}
        labelInValue={labelInValue}
        bulkActions={bulkActions}
        fetchAllOptions={fetchAllOptions}
        {...props}
      />
    </Form.Item>
  </div>
);
